import { render, staticRenderFns } from "./sportGroup.vue?vue&type=template&id=b19a84e6&scoped=true"
import script from "./sportGroup.vue?vue&type=script&lang=js"
export * from "./sportGroup.vue?vue&type=script&lang=js"
import style0 from "./sportGroup.vue?vue&type=style&index=0&id=b19a84e6&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19a84e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b19a84e6')) {
      api.createRecord('b19a84e6', component.options)
    } else {
      api.reload('b19a84e6', component.options)
    }
    module.hot.accept("./sportGroup.vue?vue&type=template&id=b19a84e6&scoped=true", function () {
      api.rerender('b19a84e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/team/sportGroup.vue"
export default component.exports